import axios from "axios";

export default axios.create({
  baseURL: window.apcConfig.partner.endpoint,
});